import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { Configuration } from '../../lead-generation/shared/domain/configuration.model';
import { getActiveProjectSelector } from '../../lead-generation/projects/projects.reducer';
import { GoToNextStateAction } from '../first-steps.actions';
import { UpdateProjectConfigurationAction } from '../../lead-generation/projects/projects.action';
import { LeadGenerationConfigurationService } from '../../lead-generation/shared/services/lead-generation-configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import rawDomainRegex from '../../lead-generation/shared/regex/rawDomainRegex';
import { markFormAsTouched } from '../../lead-generation/shared/reactive-forms/forEachElementInForm';

@Component({
  selector: 'cc-first-steps-web-call-installation',
  templateUrl: './first-steps-web-call-installation.component.html',
  styleUrls: ['./first-steps-web-call-installation.component.scss']
})
export class FirstStepsWebCallInstallationComponent implements OnInit {
  checkInstallationUrl = '';
  checkingInstallation = false;
  domainForm: FormGroup;

  private configuration: Configuration;

  constructor(
    private store: Store<IState>,
    private leadGenerationService: LeadGenerationConfigurationService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.logAmplitude('Init');
    this.domainForm = this.fb.group({
      domainName: ['', Validators.pattern(rawDomainRegex)]
    });
    this.store.select(getActiveProjectSelector).subscribe(config => {
      this.configuration = config;
    });
  }

  continueSteps() {
    if (this.domainForm.invalid) {
      this.logAmplitude('Continue - invalid domain', { domain: this.domain });
      markFormAsTouched(this.domainForm);
      return;
    }
    this.logAmplitude('Continue', { domain: this.domain });
    this.configuration.domainName = this.domain;
    this.store.dispatch(new UpdateProjectConfigurationAction(this.configuration));
    this.store.dispatch(new GoToNextStateAction());
  }

  doItLater() {
    this.logAmplitude('Do it later', { domain: this.domain });
    this.store.dispatch(new GoToNextStateAction());
  }

  showCodeInstalledStatus(isCodeInstalled: boolean) {
    this.logAmplitude('Showing installed code status', { domain: this.domain, isCodeInstalled });
    const translationKey = isCodeInstalled ? 'CODE_INSTALLED' : 'CODE_NOT_INSTALLED';
    this.translate.get(`LEAD_GENERATION.TOAST.${translationKey}`).subscribe((res: string) => {
      isCodeInstalled ? this.toastr.success(res) : this.toastr.warning(res);
    });
  }

  handleCheckInstallationClick() {
    this.logAmplitude('Checking installed code', { domain: this.domain });
    this.checkingInstallation = true;
    this.leadGenerationService.checkInstallation(this.checkInstallationUrl).subscribe(
      ({ installed }) => {
        this.showCodeInstalledStatus(installed);
      },
      () => {
        this.showCodeInstalledStatus(false);
      },
      () => {
        this.checkingInstallation = false;
      }
    );
  }

  private get domain(): string {
    return this.domainForm.controls['domainName'].value;
  }

  private logAmplitude(message: string, event?: any) {
    this.amplitudeService.logEvent(`Panel:FirstSteps:WebCallInstallation: ${message}`, event);
  }
}
